import {Radio as BaseRadio, RadioProps} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
import React from 'react'

import whiteCheck from '../icons/whiteCheck.svg'
import {theme} from '../theme'

const useStyles = makeStyles({
  icon: {
    width: 30,
    height: 30,
    border: `4px solid ${theme.palette.grey[300]}`,
    background: theme.palette.grey[300],
    borderRadius: '50%',
  },
  checked: {
    backgroundImage: `url("${whiteCheck}")`,
    backgroundColor: '#FCB900',
    borderColor: '#FCB900',
    backgroundSize: '22px auto',
  },
})

const RadioControl: React.FC<React.PropsWithChildren<RadioProps>> = props => {
  const iconClasses = useStyles()

  return (
    <BaseRadio
      {...props}
      checkedIcon={<span className={`${iconClasses.icon} ${iconClasses.checked}`} />}
      icon={<span className={iconClasses.icon} />}
    />
  )
}

export default RadioControl
